module.exports = __webpack_public_path__ + "7cb0f09b344dc000413b46f802cfb42e.MP3";